import mutations from "./mutations";

const ATTRIBUTE = "data-responsive";
const LOAD_EVENT = "load";
const RESPONSIVE_EVENT = `responsive${LOAD_EVENT}`;
const SELECTOR = `[${ATTRIBUTE}]`;
const TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

function isImageApplied(target) {
  return (
    // the load errored
    target.dataset.error ||
    // we only ever wanted TRANS anyway
    target.srcset === TRANS ||
    // currentSrc has changed
    target.currentSrc !== TRANS
  );
}

function onImageLoad({ target }) {
  if (isImageApplied(target)) {
    target.removeEventListener(LOAD_EVENT, onImageLoad);
    window.dispatchEvent(target.customEvent); // dispatch responsiveload event on window
  }
}

function onResponsiveLoad(e) {
  if (e.type === RESPONSIVE_EVENT) {
    const { src, target } = e.detail;

    delete src.customEvent;
    target.style.backgroundImage = `url("${src.currentSrc}")`;
  }
}

function processImageLoad(element) {
  const img = element.querySelector("img");

  if (!img) {
    return;
  }

  img.customEvent = new CustomEvent(RESPONSIVE_EVENT, {
    detail: {
      src: img,
      target: element
    }
  });
  img.addEventListener(LOAD_EVENT, onImageLoad);
}

function processNode(node) {
  const responsive = [].slice.call(node.querySelectorAll(SELECTOR));

  if (node.hasAttribute(ATTRIBUTE)) {
    responsive.unshift(node);
  }

  if (responsive.length) {
    responsive.forEach(processImageLoad);
  }
}

function init() {
  window.addEventListener(RESPONSIVE_EVENT, onResponsiveLoad);
  document.querySelectorAll(SELECTOR).forEach(processImageLoad);
}

document.addEventListener("DOMContentLoaded", init);

mutations.add(SELECTOR, processNode);



// WEBPACK FOOTER //
// ./shared/helpers/responsive-bg.js